import type { CSSProperties } from "react";
import type { IconBaseProps } from "react-icons";

import { appIcons, type AppIconName } from "./icon-list";

export interface IconProps extends Omit<IconBaseProps, "className" | "style"> {
  icon: AppIconName;
  className?: string;
  style?: CSSProperties;
}

export function Icon({ icon, ...props }: IconProps) {
  const IconComponent = appIcons[icon];

  return <IconComponent {...props} />;
}
